import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  saveCarnival,
  getLeadInfraId
} from 'services/redux/brandActivtion/conductCamp/action';
import {addLocationDetailsData} from 'services/redux/sales/projectOnboarding/action';
import AddClientLocationAll from './addClientLocationAll';
import {
  locationArea,
  locationCity,
  locationPinCode,
  locationState,
  locationType,
  locationZone,
} from "services/redux/sales/corporate/locations/action";
import { getCurrentLocation } from "services/redux/sales/currentLocation/action";

const mapStateToProps = (state) => ({
  cities: state.locationReducer.cities,
  zones: state.locationReducer.zones,
  areas: state.locationReducer.areas,
  state: state.locationReducer.state,
  pincodeData: state.locationReducer.pincodeData,
  locTypesData: state.locationReducer.locTypesData,
  latlng: state.currentLocationReducer.latlng,
  toastMsg: state.toastReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      locationCity,
      locationZone,
      locationArea,
      locationType,
      locationPinCode,
      locationState,
      getCurrentLocation,
      addLocationDetailsData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AddClientLocationAll);
